/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
           // eslint-disable-next-line @typescript-eslint/explicit-function-return-type

import { createContext, useContext, useState } from 'react';
import React from 'react';


export type DnDType = string | null;

type DnDContextType = [
  DnDType,
  React.Dispatch<React.SetStateAction<DnDType>>
];


const DnDContext = createContext<DnDContextType | null>(null);
// eslint-disable-next-line react/prop-types
const DnDProvider = ({ children }) => {
  const [type, setType] = useState<DnDType>(null);

  return (
    <DnDContext.Provider value={[type, setType]}>
      {children}
    </DnDContext.Provider>
  );
};

export { DnDProvider, DnDContext };

export const useDnD = () => {
  const context = useContext(DnDContext);
  if (!context) {
    throw new Error('useDnD must be used within DnDProvider');
  }
  return context;
};